import * as React from 'react'
import * as ReactRouter from 'react-router-dom'

import * as Common from '@rushplay/common'
import * as Herz from '@rushplay/herz'
import { lazy as loadable } from '@loadable/component'

import { NavigationLink, PageNavigation } from '../page-navigation'

const FaqPage = loadable(() => import('./faq-page'))
const InfoPage = loadable(() => import('./info-page'))
const PerksPage = loadable(() => import('./perks-page'))

export function VipPage() {
  const translate = Herz.I18n.useTranslate()

  return (
    <Common.Box
      flexGrow="1"
      maxWidth={['100vw', '100%']}
      pt={[1, 2]}
      display={[null, 'flex']}
      flexDirection={[null, 'column']}
      lineHeight="1.5"
    >
      <Common.Box px={[1, 2]}>
        <PageNavigation header={translate('vip')}>
          <React.Fragment>
            <NavigationLink to="/vip/info">
              {translate('vip.nav.info')}
            </NavigationLink>

            <NavigationLink to="/vip/perks">
              {translate('vip.nav.perks')}
            </NavigationLink>

            <NavigationLink to="/vip/faq">
              {translate('vip.nav.faq')}
            </NavigationLink>
          </React.Fragment>
        </PageNavigation>
      </Common.Box>
      <ReactRouter.Switch>
        <ReactRouter.Redirect exact from="/vip" to="/vip/info" />
        <ReactRouter.Route path="/vip/info" component={InfoPage} />
        <ReactRouter.Route path="/vip/perks" component={PerksPage} />
        <ReactRouter.Route path="/vip/faq" component={FaqPage} />
      </ReactRouter.Switch>
    </Common.Box>
  )
}

Herz.I18n.Loader.preload(
  ['vip', 'vip.nav.info', 'vip.nav.perks', 'vip.nav.faq'],
  VipPage
)

export default VipPage
